const isRecaptchaAvailable = (form) => window.grecaptcha && form.elements.recaptcha_check;

const enableSubmitButton = (formElement) => {
  const submitButton = formElement.querySelector('[type="submit"]');

  submitButton.removeAttribute('disabled');
};

const executeRecaptchaIfPresent = (form) => {
  if (!isRecaptchaAvailable(form)) {
    form.submit();

    return;
  }

  window.grecaptcha.reset();
  window.grecaptcha.execute();

  enableSubmitButton(form);
};

export default executeRecaptchaIfPresent;
